import { STALE_RECORD_ERROR } from './constants';

export const isStaleRecordError = (err: any): boolean =>
  err?.graphQLErrors?.[0]?.extensions?.code === STALE_RECORD_ERROR;
